           
  if (document.querySelector('#mega-mainmenu-content')){
//console.log(document.querySelector('#mega-mainmenu-content'))
          //var my_array = "{linklists[section.settings.menu].links | json}}"
            //console.log(my_array)
//            console.log(this.$refs['{section.settings.menu}}'])
            
	//var content = { pages.page-handle.content | json }};

//console.log(content)
            
          const Headerpage =Vue.createApp({
          delimiters:['${','}'],

          data() {
            
            return {
              mid: "10",
              message: "Please enter a search term",
              mlinks: ''
              //firstitem: { section.settings.menu.links[0] | json }},
              
            }
          },
            created(){
              //console.log('uiuiuiuiuiuiuiu')
              //console.log({ linklists[section.settings.menu]}});

           console.log(document.querySelector('#mega-mainmenu-content')) 
          
            },
            mounted(){


            fetch('https://navcheema.myshopify.com/api/2022-04/graphql.json', {

            method: 'POST',

            headers: { 'Content-Type': 'application/json','X-Shopify-Storefront-Access-Token': 'e656d0e560b7a906883e880023e059ec' },

            body: JSON.stringify({ query: `

            {

                menu(handle: "main-menu") {

                  items {

                    id
                    tags
                    title
					url
					items {
                      id
                      url
                      title
					items{
                        id
                        title
                        url
                      }
                    }

                  }

                }

              }

              `

            }),

            })

            .then(res => res.json())

            .then(res => this.mlinks = res.data.menu.items);    

        },
          }).mount('#mega-mainmenu-content')
   }
